import api from './api'
import type { University, Institution } from '@/types'

export interface UniversitiesResponse {
  universities: University[]
}

export interface InstitutionsResponse {
  institutions: Institution[]
}

/**
 * Fetches all universities (public endpoint)
 */
export const getUniversities = async (): Promise<UniversitiesResponse> => {
  const response = await api.get('/universities')
  return response.data
}

/**
 * Fetches institutions for a specific university (public endpoint)
 * @param universityId - The university ID
 */
export const getInstitutionsByUniversity = async (
  universityId: string
): Promise<InstitutionsResponse> => {
  const response = await api.get(`/universities/${universityId}/institutions`)
  return response.data
}

/**
 * Fetches all institutions with university information (public endpoint)
 */
export const getAllInstitutions = async (): Promise<InstitutionsResponse> => {
  const response = await api.get('/universities/institutions/all')
  return response.data
}

export const universityService = {
  getUniversities,
  getInstitutionsByUniversity,
  getAllInstitutions,
}
